/// <reference path="../classes/User.ts"/>
module App.Interfaces {
    export interface IAccountService {
        login();
        logout();
        createAccount(firstName: string, lastName:string, licensePlate:string, email:string);
        getUser(): ng.IPromise<Classes.User>;
        user: Classes.User;
        isAuthenticated: boolean;
    }
}